export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageCommunity',
  },
  {
    documentType: 'pageCourseDetail',
  },
  {
    documentType: 'pageCourseGallery',
  },
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageLeaderboard',
  },
  {
    documentType: 'pageLegal',
  },
  {
    documentType: 'pageManifesto',
  },
  {
    documentType: 'pageThankyou',
  },
  {
    documentType: 'pageReviews',
  },
  {
    documentType: 'pageMentors',
  },
  {
    documentType: 'pageMentor',
  },
];
